import PropTypes from "prop-types";
import { memo } from "react";
import Merchandising from "app/pages/Listing/merchandising/Merchandising";
import { RESOLUTION } from "app/constants";
import { resolutionPropType } from "app/utils/propTypes";
import "./triple-merchandising-carousel.scss";
import get from "lodash/get";
import Swiper from "react-id-swiper";
import SimpleProgressiveImg from "app/pages/.shared/SimpleProgressiveImg";
import Loader from "app/pages/.shared/Loader";
import { ArrowRightIcon, ArrowLeftIcon } from "app/icons/navigation";

const IMG_SIZES = {
	large: { width: 500, height: 438 },
	medium: { width: 500, height: 438 },
	xlarge: { width: 500, height: 438 },
	small: { width: 500, height: 438 },
};

const resolutionParams = {
	[RESOLUTION.XLARGE]: {
		slidesPerView: 3,
		loopedSlides: 4,
	},
	[RESOLUTION.LARGE]: {
		slidesPerView: 3,
		loopedSlides: 4,
	},
	[RESOLUTION.MEDIUM]: {
		slidesPerView: 2.2,
		loopedSlides: 4,
	},
	[RESOLUTION.SMALL]: {
		slidesPerView: 1.5,
		loopedSlides: 3,
	},
};

const TripleMerchandisingCarousel = ({ merchandisingList, resolution }) => {
	const swiperParams = {
		spaceBetween: 10,
		navigation: {
			nextEl: ".triple-merchandising-carousel__button--next",
			prevEl: ".triple-merchandising-carousel__button--previous",
		},
		loop: true,
		rebuildOnUpdate: true,
		containerClass: "swiper-container triple-merchandising-carousel",
		// eslint-disable-next-line react/no-multi-comp
		renderPrevButton: () => (
			<div className="triple-merchandising-carousel__button triple-merchandising-carousel__button--previous">
				<ArrowLeftIcon className="icon icon--previous" />
			</div>
		),
		// eslint-disable-next-line react/no-multi-comp
		renderNextButton: () => (
			<div className="triple-merchandising-carousel__button triple-merchandising-carousel__button--next">
				<ArrowRightIcon className="icon icon--next" />
			</div>
		),
		...resolutionParams[resolution],
	};

	// pour ajouter un espace vide pour le carousel pour eviter que les elements bougent quand le carousel apparait
	let carouselHeight = "auto";

	if (
		resolution === RESOLUTION.LARGE ||
		resolution === RESOLUTION.XLARGE ||
		resolution === RESOLUTION.MEDIUM
	) {
		carouselHeight = "293.16px";
	} else if (resolution === RESOLUTION.SMALL) {
		carouselHeight = "200px";
	}

	const isServerSide = typeof window === "undefined";

	// le premier rendu du carousel n'est pas satisfaisant. On préfère ne rien rendre
	return isServerSide ? (
		<div
			style={{
				minHeight: carouselHeight,
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<Loader />
		</div>
	) : (
		<div style={{ minHeight: carouselHeight }}>
			<Swiper {...swiperParams}>
				{merchandisingList.map(merchandising => {
					let imageSrc = false;

					if (
						resolution === RESOLUTION.LARGE ||
						resolution === RESOLUTION.XLARGE ||
						resolution === RESOLUTION.MEDIUM
					) {
						imageSrc = get(merchandising, "photoLarge.url");
					} else if (resolution === RESOLUTION.SMALL) {
						imageSrc = get(merchandising, "photoSmall.url");
					}

					// En preview, le back nous renvoie les merch de même code. Coté front on veut pouvoir afficher les 2
					const merchKey = `${merchandising.code}-${merchandising.startAt}`;

					return (
						<div key={merchKey}>
							<Merchandising
								forceClickOnPicture={true}
								imageElement={
									<SimpleProgressiveImg
										resolution={resolution}
										sizes={IMG_SIZES}
										src={imageSrc}
									/>
								}
								merchandisingCode={merchandising.code}
								position={merchandising.position}
								indexCarousel={merchandising.headerIndex}
								endAt={merchandising.endAt}
								countdownPosition={get(merchandising, "countdown.position")}
								countdownTextColor={get(merchandising, "countdown.textColor")}
								countdownStartAt={get(merchandising, "countdown.startAt")}
								countdownEndAt={get(merchandising, "countdown.endAt")}
								daysInHours={get(merchandising, "countdown.daysInHours")}
								redirectUrl={get(merchandising, "redirectUrl")}
							/>
						</div>
					);
				})}
			</Swiper>
		</div>
	);
};

TripleMerchandisingCarousel.propTypes = {
	merchandisingList: PropTypes.arrayOf(PropTypes.object),
	resolution: resolutionPropType,
};

TripleMerchandisingCarousel.defaultProps = {
	merchandisingList: [],
};

export default memo(TripleMerchandisingCarousel);
